module.exports = __webpack_public_path__ + "static/media/kullerbytta.239cdca7.mp3";